import React from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

import styles from "./Profile.module.scss";
const cx = classNames.bind(styles);

const MenuDropDown = ({ handleLogout }) => {
  return (
    <ul className={cx("menu-dropdown-root")}>
      <Link to="/myevents">
        <li>My Events</li>
      </Link>
      {/* <Link to="/profile">
        <li>Profile</li>
      </Link> */}
      <li onClick={handleLogout}>Logout</li>
    </ul>
  );
};

export default MenuDropDown;
